interface Props {
  label: string
  value: string
  onChange: (v: string) => void
  placeholder?: string
  required?: boolean
  disabled?: boolean
}

export function TextField({ label, value, onChange, placeholder, required, disabled }: Props) {
  return (
    <div className="flex flex-col gap-xs">
      <label className="text-sm text-secondary font-medium">
        {label}
        {required && <span className="text-destructive ml-xs">*</span>}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className="text-base min-h-edit-field border rounded-md p-s"
      />
    </div>
  )
}
